/* ============================================================
   Matraws fuldbredde-søgning — mtw-search.js
   - Kaprer søge-ikonet (capture-fase, så temaets side-drawer ikke også åbner)
   - Henter Matraws-stylede resultater via /search/suggest?section_id=mtw-predictive
   - Debounce, keyboard-nav, seneste søgninger (localStorage)
   - Fejler noget: søge-ikonet beholder sin native adfærd (intet kapres før DOM er klar)
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('mtw-search');
  if (!root) return;

  var input     = root.querySelector('[data-mtw-input]');
  var form      = root.querySelector('[data-mtw-form]');
  var clearBtn  = root.querySelector('[data-mtw-clear]');
  var panel     = root.querySelector('[data-mtw-panel]');
  var resultsEl = root.querySelector('[data-mtw-results]');
  var idleEl    = root.querySelector('[data-mtw-idle]');
  var loadingEl = root.querySelector('[data-mtw-loading]');
  var recentWrap = root.querySelector('[data-mtw-recent]');
  var recentList = root.querySelector('[data-mtw-recent-list]');
  var recentClear = root.querySelector('[data-mtw-recent-clear]');

  var RECENT_KEY = 'mtw-recent-searches';
  var MIN_CHARS  = 2;
  var DEBOUNCE   = 190;
  var RESOURCES  = 'product,collection,query';
  var LIMIT      = 8;

  var cache = {};
  var currentController = null;
  var debounceTimer = null;
  var activeIndex = -1;
  var isOpen = false;

  /* ---------- recent searches ---------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; }
    catch (e) { return []; }
  }
  function saveRecent(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    list = list.slice(0, 6);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function renderRecent() {
    if (!recentWrap || !recentList) return;
    var list = getRecent();
    if (!list.length) { recentWrap.hidden = true; recentList.innerHTML = ''; return; }
    recentWrap.hidden = false;
    recentList.innerHTML = '';
    list.forEach(function (term) {
      var a = document.createElement('a');
      a.className = 'mtw-search__chip';
      a.href = mainSearch(term);
      a.setAttribute('data-mtw-chip', '');
      a.setAttribute('data-mtw-term', term);
      a.textContent = term;
      recentList.appendChild(a);
    });
  }

  function mainSearch(term) {
    return (window.mainSearchUrl || '/search') + '?q=' + encodeURIComponent(term) + '&type=product';
  }

  /* ---------- open / close ---------- */
  function open(seed) {
    if (isOpen) return;
    isOpen = true;
    root.hidden = false;
    if (input && typeof seed === 'string' && seed.trim()) { input.value = seed; }
    document.documentElement.classList.add('mtw-search-open');
    renderRecent();
    // force reflow so the transition runs
    void root.offsetWidth;
    root.classList.add('is-open');
    setTimeout(function () { if (input) input.focus(); }, 60);
    if (input && input.value.trim().length >= MIN_CHARS) { runSearch(input.value); }
    else { showIdle(); }
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('mtw-search-open');
    if (currentController) { currentController.abort(); currentController = null; }
    var done = function () {
      root.hidden = true;
      root.removeEventListener('transitionend', onEnd);
    };
    var onEnd = function (e) { if (e.target === root.querySelector('.mtw-search__sheet')) done(); };
    root.addEventListener('transitionend', onEnd);
    setTimeout(done, 320); // fallback hvis transitionend ikke fyrer
  }

  /* ---------- view states ---------- */
  function showIdle() {
    activeIndex = -1;
    if (loadingEl) loadingEl.hidden = true;
    if (resultsEl) { resultsEl.hidden = true; }
    if (idleEl) idleEl.hidden = false;
    if (clearBtn) clearBtn.hidden = !(input && input.value.length);
  }
  function showLoading() {
    if (idleEl) idleEl.hidden = true;
    if (resultsEl) resultsEl.hidden = true;
    if (loadingEl) loadingEl.hidden = false;
  }
  function showResults(html) {
    activeIndex = -1;
    if (idleEl) idleEl.hidden = true;
    if (loadingEl) loadingEl.hidden = true;
    if (resultsEl) { resultsEl.innerHTML = html; resultsEl.hidden = false; panel.scrollTop = 0; }
  }

  /* ---------- fetch ---------- */
  function buildUrl(term) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + 'search/suggest'
      + '?q=' + encodeURIComponent(term)
      + '&section_id=mtw-predictive'
      + '&resources[type]=' + RESOURCES
      + '&resources[limit]=' + LIMIT
      + '&resources[options][unavailable_products]=show'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
  }

  function extractInner(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var inner = doc.querySelector('[data-mtw-results-inner]');
    return inner ? inner.outerHTML : null;
  }

  function runSearch(raw) {
    var term = (raw || '').trim();
    if (term.length < MIN_CHARS) { showIdle(); return; }

    if (cache[term]) { showResults(cache[term]); return; }
    if (currentController) currentController.abort();
    currentController = ('AbortController' in window) ? new AbortController() : null;
    showLoading();

    fetch(buildUrl(term), currentController ? { signal: currentController.signal } : undefined)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        // ignorér forældet svar hvis inputtet har ændret sig
        if (input.value.trim() !== term) return;
        var html = extractInner(text);
        if (html == null) { showIdle(); return; }
        cache[term] = html;
        showResults(html);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        showIdle();
      });
  }

  /* ---------- keyboard nav ---------- */
  function navItems() {
    var scope = (resultsEl && !resultsEl.hidden) ? resultsEl : idleEl;
    if (!scope || scope.hidden) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('[data-mtw-item], [data-mtw-chip]'));
  }
  function setActive(idx) {
    var items = navItems();
    items.forEach(function (el) { el.classList.remove('is-active'); });
    if (idx < 0 || !items.length) { activeIndex = -1; return; }
    activeIndex = (idx + items.length) % items.length;
    var el = items[activeIndex];
    el.classList.add('is-active');
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
  }

  /* ---------- events ---------- */
  // Kapring af søge-triggere i capture-fase (før temaets egne click-handlers)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.header-icons-link.search, [data-search-open], [data-mtw-search-open]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    open();
  }, true);

  // Den indlejrede header-søgebjælke (logo_with_search_bar): klik/fokus åbner
  // fuldbredde-overlayet i stedet for den gamle dropdown. Ikke vores eget input.
  function headerSearchInput(el) {
    if (!el || !el.closest) return null;
    var inp = el.closest('[data-search-input]');
    if (!inp || inp.closest('#mtw-search')) return null;
    return inp;
  }
  document.addEventListener('mousedown', function (e) {
    var inp = headerSearchInput(e.target);
    if (!inp) return;
    e.preventDefault(); // forhindrer fokus + temaets egen dropdown
    e.stopPropagation();
    open(inp.value);
  }, true);
  document.addEventListener('focusin', function (e) {
    var inp = headerSearchInput(e.target);
    if (!inp || isOpen) return;
    open(inp.value); // open() flytter selv fokus til overlay-inputtet
  }, true);

  root.querySelectorAll('[data-mtw-close]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); close(); });
  });

  if (input) {
    input.addEventListener('input', function () {
      if (clearBtn) clearBtn.hidden = !input.value.length;
      clearTimeout(debounceTimer);
      var v = input.value;
      if (v.trim().length < MIN_CHARS) { showIdle(); return; }
      debounceTimer = setTimeout(function () { runSearch(v); }, DEBOUNCE);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === 'Enter') {
        var items = navItems();
        if (activeIndex >= 0 && items[activeIndex]) {
          e.preventDefault();
          var el = items[activeIndex];
          saveRecent(el.getAttribute('data-mtw-term') || input.value);
          window.location.href = el.href;
        } else {
          saveRecent(input.value); // native submit navigerer til /search
        }
      } else if (e.key === 'Escape') {
        e.preventDefault(); close();
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function () { saveRecent(input.value); });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      showIdle();
      input.focus();
    });
  }

  if (recentClear) {
    recentClear.addEventListener('click', function () {
      try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
      renderRecent();
    });
  }

  // Gem søgeord når man klikker et forslag/chip
  root.addEventListener('click', function (e) {
    var it = e.target.closest && e.target.closest('[data-mtw-term]');
    if (it) saveRecent(it.getAttribute('data-mtw-term'));
    var card = e.target.closest && e.target.closest('.mtw-card, .mtw-sr__cat, .mtw-search__cat-pill');
    if (card && input && input.value.trim()) saveRecent(input.value);
  });

  // ESC globalt (også hvis fokus forlader inputtet)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) { close(); }
  });
})();
